import { AlertCircle, X } from 'lucide-react';

export const Banner = ({ children }) => (
    <div className="mb-4 p-4 bg-red-50 border border-red-200 rounded-lg text-red-700 text-sm flex items-start gap-2.5">
        <AlertCircle className="w-4 h-4 shrink-0 mt-0.5" />
        <span>{children}</span>
    </div>
);

const ModalShell = ({ title, onRequestClose, children }) => (
    <>
        <div className="fixed inset-0 z-40 bg-black/30 backdrop-blur-sm" onClick={onRequestClose} />

        <div className="fixed inset-0 z-50 flex items-end sm:items-center justify-center sm:p-4 pointer-events-none">
            <div
                role="dialog"
                aria-modal="true"
                aria-labelledby="new-simulation-title"
                className="pointer-events-auto w-full sm:max-w-[500px] max-h-[90vh] overflow-y-auto bg-white rounded-t-2xl sm:rounded-2xl shadow-lg border border-[#E8E6E3]"
            >
                <div className="flex items-center justify-between gap-3 px-5 md:px-6 py-4 border-b border-[#E8E6E3]">
                    <h2 id="new-simulation-title" className="text-[19px] text-[#2D2D2D] leading-none">
                        {title}
                    </h2>
                    <button
                        type="button"
                        onClick={onRequestClose}
                        className="shrink-0 w-8 h-8 rounded-full bg-[#F5F3F0] hover:bg-[#E8E6E3] flex items-center justify-center transition-colors"
                    >
                        <X className="w-3.5 h-3.5 text-[#6B6B6B]" />
                        <span className="sr-only">Close</span>
                    </button>
                </div>

                <div className="px-5 md:px-6 py-5">{children}</div>
            </div>
        </div>
    </>
);

export default ModalShell;
